import { css } from "styled-components";

export const clickableCursorStyle = css`
    cursor: pointer;
`;

export const disabledCursorStyle = css`
    cursor: not-allowed;
`;

export const textCursorStyle = css`
    cursor: vertical-text;
`;
